import React from 'react'
import { T } from '@transifex/react'
import { message } from 'antd'

import { asyncModal } from 'src/utils/asyncModalAction'

import { FormAppUrlChange } from '../forms/app-config'

export const isProductionHostname =
  window.location.hostname === process.env.REACT_APP_PRODUCTION_DOMAIN

export const changeApiUrl = () => {
  if (!isProductionHostname)
    asyncModal({
      title: <T _str="Change api url" />,
      children: ({ reject }) => (
        <FormAppUrlChange
          formId="ChangeApiUrlForm"
          onCancel={() => reject(asyncModal.CANCEL)}
        />
      ),
      modalStyles: {
        body: {
          padding: 0,
        },
      },
    }).catch((e) => {
      if (e !== asyncModal.CANCEL)
        message.error(e?.message || <T _str="Error occurred" />)
    })
}
